import React from "react";
import { AlertDeletePeripheralMessage } from "@components/Common/AlertDeletePeripheralMessage";
import { ConfirmationDeleteMessage } from "@components/Common/ConfirmationDeleteMessage";
import { ConfirmationMultiDeleteMessage } from "@components/Common/ConfirmationMultiDeleteMessage";
import AlertSvgIcon from "@components/Common/SvgIcons/AlertSvgIcon";

function Delete({
    isMultiDeletePeripheralModalOpened,
    setIsMultiDeletePeripheralModalOpened,
    typeDisplay,
    oneShop,
    shops,
    shopID,
    t,
    applicationsShopIds,
    shopNames,
    redisData,
    isModalDeleteAssociatePeripheralOpened,
    textModal,
    setIsModalDeleteAssociatePeripheralOpened,
    isModalOpened,
    setIsModalOpened,
    setGlobalDataIsUpdated,
    apiUrl,
    isDeletePeripheralModalOpened,
    displayMode,
    rowData,
    shopId,
    userID,
    franchiseID,
    appId,
    applicationChildrenId,
    peripheralId,
    operatorID,
    uuidUser,
    setKey,
    setIsLoading,
}: any) {
    return (
        <div>
            {isMultiDeletePeripheralModalOpened === true && (
                <ConfirmationMultiDeleteMessage
                    isModalOpened={isMultiDeletePeripheralModalOpened}
                    setIsModalOpened={setIsMultiDeletePeripheralModalOpened}
                    appMessage={
                        typeDisplay === "notArchived"
                            ? oneShop && shops.includes(shopID)
                                ? t(
                                      "Please note, one or more applications are associated with a published Template."
                                  )
                                : shops.some((el: any) =>
                                      applicationsShopIds.includes(el)
                                  )
                                ? `${t(
                                      "Please note, one or more applications are associated with a published Template. See the stores:"
                                  )}  ${shopNames.join()}`
                                : ""
                            : ""
                    }
                    redisData={redisData}
                />
            )}
            {isModalDeleteAssociatePeripheralOpened === true ? (
                <AlertDeletePeripheralMessage
                    text={textModal}
                    isModalDeleteAssociatePeripheralOpened={
                        isModalDeleteAssociatePeripheralOpened
                    }
                    setIsModalDeleteAssociatePeripheralOpened={
                        setIsModalDeleteAssociatePeripheralOpened
                    }
                />
            ) : oneShop === true ? (
                <ConfirmationDeleteMessage
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                    apiUrl={apiUrl}
                    text={
                        isDeletePeripheralModalOpened === true ? (
                            displayMode !== t("View by device") ? (
                                t("Please confirm unpairing this device")
                            ) : rowData.subRows !== undefined &&
                              rowData.subRows.length > 0 ? (
                                <div className="d-flex flex-column">
                                    <span>
                                        {t(
                                            "This device contains associated applications"
                                        )}
                                        !
                                    </span>
                                    <span>
                                        {t(
                                            "Please confirm archiving of this device"
                                        )}
                                    </span>
                                </div>
                            ) : (
                                t("Please confirm archiving of this device")
                            )
                        ) : typeDisplay === "notArchived" &&
                          displayMode !== t("View by device") ? (
                            t(
                                "Do you want to confirm the archiving of the selected application?"
                            )
                        ) : typeDisplay === "notArchived" &&
                          displayMode === t("View by device") ? (
                            t(
                                "Do you want to confirm the dissociation of the selected application?"
                            )
                        ) : (
                            t(
                                "Do you want to confirm the unarchiving of the selected application?"
                            )
                        )
                    }
                    message={
                        typeDisplay === "notArchived"
                            ? displayMode !== t("View by device")
                                ? t(
                                      "Unpairing of this device has been successfully completed"
                                  )
                                : t(
                                      "Unlinking of this application has been successfully completed"
                                  )
                            : displayMode === t("View by device")
                            ? t("The device was successfully unarchived")
                            : t("This application was successfully unarchived")
                    }
                    appMessage={
                        <div className="d-flex flex-column">
                            {typeDisplay === "notArchived" &&
                            displayMode !== t("View by device") &&
                            shops.includes(shopId) ? (
                                <span className="d-flex align-item-between">
                                    <AlertSvgIcon className="mr-1" />
                                    <div style={{ color: "#e31111" }}>
                                        {t(
                                            "Please note, this application is associated with a published Template."
                                        )}
                                    </div>
                                </span>
                            ) : null}
                        </div>
                    }
                    data={{
                        userId: userID,
                        shopId: shopId,
                        franchiseId: franchiseID,
                        appId: appId,
                        appId_children: [applicationChildrenId],
                        peripheralId: peripheralId,
                        peripheralName: {
                            [applicationChildrenId]:
                                displayMode === t("View by device")
                                    ? [rowData.peripheral]
                                    : [rowData[t("Peripheral")]],
                        },
                        operatorId: operatorID,
                        uuidUser: uuidUser,
                        isArchived:
                            typeDisplay === "notArchived" ? true : false,
                        applicationName: [rowData.appName],
                        ids: { [applicationChildrenId]: [peripheralId] },
                    }}
                    setKey={setKey}
                    setIsLoading={setIsLoading}
                />
            ) : (
                <ConfirmationDeleteMessage
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                    apiUrl={apiUrl}
                    message={
                        isDeletePeripheralModalOpened === true
                            ? t(
                                  "Unpairing of this device has been successfully completed"
                              )
                            : t(
                                  "Unlinking of this application has been successfully completed"
                              )
                    }
                    appMessage={
                        !isDeletePeripheralModalOpened &&
                        displayMode !== t("View by device") &&
                        (rowData.subRows === undefined ||
                            rowData.subRows.length === 0) &&
                        typeDisplay === "notArchived" &&
                        shops.includes(shopId) ? (
                            <div className="d-flex flex-column">
                                <span className="d-flex align-item-between">
                                    <AlertSvgIcon className="mr-1" />
                                    <div style={{ color: "#e31111" }}>
                                        {t(
                                            "Please note, this application is associated with a published Template."
                                        )}
                                    </div>
                                </span>
                            </div>
                        ) : null
                    }
                    text={
                        isDeletePeripheralModalOpened === true ? (
                            displayMode !== t("View by device") ? (
                                t("Please confirm unpairing this device")
                            ) : rowData.subRows !== undefined &&
                              rowData.subRows.length > 0 ? (
                                <div className="d-flex flex-column">
                                    <span>
                                        {t(
                                            "This device contains associated applications"
                                        )}
                                        !
                                    </span>
                                    <span>
                                        {t(
                                            "Please confirm deletion of this device"
                                        )}
                                    </span>
                                </div>
                            ) : (
                                t("Please confirm deletion of this device")
                            )
                        ) : rowData.subRows !== undefined &&
                          rowData.subRows.length > 0 ? (
                            <div className="d-flex flex-column">
                                <span>
                                    {t(
                                        "This application contains associated devices!"
                                    )}
                                </span>
                                <span>
                                    {t(
                                        typeDisplay === "notArchived"
                                            ? "Do you want to confirm the archiving of the selected application?"
                                            : "Do you want to confirm the unarchiving of the selected application?"
                                    )}
                                </span>
                            </div>
                        ) : displayMode !== t("View by device") ? (
                            t(
                                typeDisplay === "notArchived"
                                    ? "Do you want to confirm the archiving of the selected application?"
                                    : "Do you want to confirm the unarchiving of the selected application?"
                            )
                        ) : (
                            t("Please confirm unpairing of the application")
                        )
                    }
                    data={{
                        userId: userID,
                        shopId: shopId,
                        franchiseId: franchiseID,
                        appId: appId,
                        appId_children:
                            applicationChildrenId !== ""
                                ? typeof applicationChildrenId === "string"
                                    ? [applicationChildrenId]
                                    : [...applicationChildrenId]
                                : [],
                        peripheralId: peripheralId,
                        peripheralName: {
                            [applicationChildrenId]:
                                displayMode === t("View by device")
                                    ? [rowData.peripheral]
                                    : [rowData[t("Peripheral")]],
                        },
                        operatorId: operatorID,
                        uuidUser: uuidUser,
                        isArchived:
                            typeDisplay === "notArchived" ? true : false,
                        applicationName: [rowData.appName],
                        ids: { [applicationChildrenId]: [peripheralId] },
                    }}
                    setKey={setKey}
                    setIsLoading={setIsLoading}
                />
            )}
        </div>
    );
}

export default Delete;
